export default __webpack_public_path__ + "static/media/ethan agarwal.55b3939e.jpg";